import { IClassname } from '@/lib/shared/model/classname';

export const SvgChevronLeft = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="8"
      height="20"
      viewBox="0 0 4 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.808 6.016L0.358 5.578L2.728 3.22L0.358 0.862L0.808 0.424L3.598 3.22L0.808 6.016Z"
        fill="currentColor"
      />
    </svg>
  );
};
